/**************************************************
 * Nombre:       Tarjeta_Caracteristicas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Tarjeta_Caracteristicas = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{color: '#fff'}}
        >

            <Grid container size={{xs: 4, sm: 3, md: 3}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.img} width={item.largo} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 8, sm: 9, md: 9}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 16, fontWeight: 400, lineHeight: 1.1}}>{item.nombre}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Caracteristicas